import { GetCustomerMetricsResponseType } from './getCustomerMetricsQuery';

export const parseGetCustomerMetricsQuery = (
  response: GetCustomerMetricsResponseType
) => {
  return response.data.attributes;
};
